import { Header } from "Components/header/Header";
import Text from "Components/shared/text";
import React, { useState } from "react";
import { Storage } from "utils/clientStorage";
import { DashboardContainer } from "./DashboardContainer";
import { DashboardLeft } from "./DashboardLeft";
import { DashboardRight } from "./DashboardRight";

export const Dashboard = () => {
  const [transaction, setTransaction] = useState(true);
  const hello = useState(0)
  console.log('TRANSACTION ', hello)

  const handleClick = () => {
    setTransaction(!transaction);
  };

  // console.log('HELLO WORKD ', Storage.getItem('userProfile'))

  return (
    <Text tag="div">
      <Header />
      <DashboardContainer>
        <DashboardLeft transaction={transaction} handleClick={handleClick} />
        <DashboardRight transaction={transaction} />
      </DashboardContainer>
    </Text>
  );
};
